import React from 'react';
import { Link } from 'react-router-dom';
import { 
  MobileIcon, 
  DigitalMarketingIcon,
  UIUXIcon,
  SoftwareDevIcon,
  WebDevIcon,
  CustomAppsIcon,
  CloudIcon,
  BrandingIcon,
  SecurityIcon,
  WebHostingIcon,
  SEOIcon,
  ConsultingIcon,
  DomainIcon,
  EcommerceIcon,
  ERPIcon,
  EmailIcon,
  MaintenanceIcon
} from '@/components/ServiceIcons';
import ClientLogos from '@/components/ClientLogos';
import HeroArrowIcon from '@/components/HeroArrowIcon';
import SEO from '@/components/SEO';
import WebDesignLocations from '@/components/WebDesignLocations';
import './OurServices.css';

const services = [
  {
    id: 1,
    title: 'Web Design & Development',
    description: 'Responsive websites with modern design and functionality',
    price: '1,500-4,000',
    limitedOffer: '1,299',
    isPopular: true,
    Icon: WebDevIcon,
    path: '/web-design-development'
  },
  {
    id: 2,
    title: 'Premium UI/UX Design',
    description: 'Beautiful interfaces that enhance user experience',
    price: '1,200-3,500',
    isPopular: true,
    Icon: UIUXIcon,
    path: '/ui-ux'
  },
  {
    id: 3,
    title: 'Enterprise Mobile Solutions',
    description: 'Premium mobile applications with white-glove service',
    price: '2,500-5,000',
    limitedOffer: '1,999',
    isPopular: true,
    Icon: MobileIcon,
    path: '/mobile-app-development'
  },
  {
    id: 4,
    title: 'Strategic Digital Marketing',
    description: 'Data-driven campaigns with guaranteed ROI',
    price: '1,000-3,000',
    limitedOffer: '899',
    isPopular: true,
    Icon: DigitalMarketingIcon,
    path: '/digital-marketing'
  },
  {
    id: 5,
    title: 'Enterprise Software Development',
    description: 'Custom software solutions for large-scale businesses',
    price: '5,000-15,000',
    limitedOffer: '4,499',
    Icon: SoftwareDevIcon,
    path: '/software-development'
  },
  {
    id: 6,
    title: 'Custom Applications',
    description: 'Bespoke applications for your unique business requirements',
    price: '2,500-6,000',
    limitedOffer: '2,299',
    Icon: CustomAppsIcon,
    path: '/custom-apps'
  },
  {
    id: 7,
    title: 'Cloud Services',
    description: 'Cloud infrastructure setup and management services',
    price: '750-2,000',
    limitedOffer: '699',
    Icon: CloudIcon,
    path: '/cloud-services'
  },
  {
    id: 8,
    title: 'Branding',
    description: 'Complete branding solutions including logo and identity design',
    price: '750-2,500',
    limitedOffer: '699',
    Icon: BrandingIcon,
    path: '/branding'
  },
  {
    id: 9,
    title: 'Cyber Security',
    description: 'Protection solutions for your digital assets and data',
    price: '1,200-4,000',
    limitedOffer: '1,099',
    Icon: SecurityIcon,
    path: '/cyber-security'
  },
  {
    id: 10,
    title: 'Web Hosting',
    description: 'Reliable and secure web hosting solutions',
    price: '125-1,250/year',
    limitedOffer: '99',
    Icon: WebHostingIcon,
    path: '/web-hosting'
  },
  {
    id: 11,
    title: 'SEO',
    description: 'Search engine optimization to improve your online visibility',
    price: '375-1,500',
    limitedOffer: '349',
    Icon: SEOIcon,
    path: '/seo'
  },
  {
    id: 12,
    title: 'Consulting',
    description: 'Expert advice for your technology and digital strategy',
    price: '375-1,000/hr',
    limitedOffer: '349',
    Icon: ConsultingIcon,
    path: '/consulting'
  },
  {
    id: 13,
    title: 'Domain Registration',
    description: 'Secure your perfect domain name for your business',
    price: '25-250/year',
    limitedOffer: '19',
    Icon: DomainIcon,
    path: '/domain-registration'
  },
  {
    id: 14,
    title: 'E-Commerce',
    description: 'Online store setup with payment integration',
    price: '2,000-5,000',
    limitedOffer: '1,999',
    Icon: EcommerceIcon,
    path: '/ecommerce'
  },
  {
    id: 15,
    title: 'ERP/CRM',
    description: 'Enterprise resource planning and customer relationship systems',
    price: '5,000-15,000',
    limitedOffer: '4,499',
    Icon: ERPIcon,
    path: '/erp-crm'
  },
  {
    id: 16,
    title: 'Email Hosting',
    description: 'Professional email solutions with your domain',
    price: '75-625/user/month',
    limitedOffer: '69',
    Icon: EmailIcon,
    path: '/email-hosting'
  },
  {
    id: 17,
    title: 'Maintenance & Support',
    description: 'Ongoing technical support and maintenance packages',
    price: '250-1,250/month',
    limitedOffer: '199',
    Icon: MaintenanceIcon,
    path: '/maintenance-support'
  },
  {
    id: 18,
    title: 'Data Analytics & BI',
    description: 'Advanced analytics and business intelligence solutions',
    price: '750-2,500/month',
    limitedOffer: '699',
    Icon: ERPIcon, 
    path: '/data-analytics'
  }
];

const OurServices = () => {
  return (
    <div className="services-page">
      <SEO
        title="Our Services – 17+ Software, Web & App Solutions in UAE | First Soft UAE"
        description="Explore 17+ expert services by First Soft UAE in UAE, including software development, web design, mobile apps, and digital marketing solutions."
        keywords="web development, mobile apps, SEO services, digital marketing, UAE tech company"
      />
      <div className="hero-section">
        <div className="hero-content">
          <div className="credibility-badge">
            <span>🏆 Award-Winning</span>
            <span>•</span>
            <span>💼 500+ Clients</span>
            <span>•</span>
            <span>⭐ 98% Satisfaction</span>
          </div>
          <h1>
            <span className="hero-title-line">Transform Your Digital</span>
            <span className="hero-title-line gradient-text">Presence Today</span>
          </h1>
          <p className="hero-subtitle">
            First Soft UAE is a leading UAE-based software, web, and app development company, trusted by startups, SMEs, and enterprises since 2017. We deliver custom digital solutions that drive business growth, enhance brand visibility, and boost online performance. From innovative websites to powerful mobile apps, our services are tailored to meet the unique needs of businesses in Dubai, Sharjah, Abu Dhabi, and beyond.
          </p>
          <div className="hero-buttons">
            <Link to="/contact" className="primary-button">
              <span>Get Your Free Strategy Session</span>
              <HeroArrowIcon />
            </Link>
            <Link to="/portfolio" className="secondary-button">
              See Our Success Stories
            </Link>
          </div>
          <ClientLogos />
        </div>
      </div>

      {/* Why Choose First Soft UAE Section */}
      <section className="why-firstsoft-section bg-white py-12">
        <div className="container mx-auto px-6">
          <h2 className="text-2xl font-bold mb-4">Why Choose First Soft UAE?</h2>
          <ul className="list-disc pl-5 text-lg text-gray-700 space-y-2">
            <li>Proven expertise in web design, app development, and digital marketing for UAE businesses</li>
            <li>Full-service agency: design, development, branding, hosting, SEO, and support—all under one roof</li>
            <li>Dedicated project managers and 24/7 support</li>
            <li>Transparent pricing and fast delivery timelines</li>
            <li>Trusted by 500+ clients across Dubai, Sharjah, Abu Dhabi, and the Middle East</li>
          </ul>
        </div>
      </section>

      {/* Industries Served Section */}
      <section className="industries-section bg-gray-50 py-8">
        <div className="container mx-auto px-6">
          <h2 className="text-xl font-semibold mb-2">Industries We Serve</h2>
          <p className="text-gray-700 mb-0">
            First Soft UAE delivers digital solutions for retail, healthcare, education, real estate, hospitality, logistics, e-commerce, and more. Our team understands the unique challenges and opportunities in each sector, ensuring your project’s success.
          </p>
        </div>
      </section>

      <section className="services-section">
        <div className="section-header">
          <h2>Our Services</h2>
          <p>Comprehensive solutions for your digital transformation</p>
        </div>
        
        <div className="services-grid">
          {services.map(({ id, title, description, price, limitedOffer, isPopular, Icon, path }) => {
            // Expanded SEO descriptions for each service
            const seoDescriptions = {
              'Web Design & Development': 'Our expert team creates visually stunning, responsive websites optimized for SEO and conversions. We use the latest technologies to ensure your site loads fast and delivers a seamless user experience on all devices.',
              'Premium UI/UX Design': 'Enhance your brand with modern UI/UX design. We focus on usability, accessibility, and aesthetics to maximize engagement and customer satisfaction.',
              'Enterprise Mobile Solutions': 'Get custom mobile apps for iOS and Android, built for performance and security. Our apps help you reach more customers and streamline business operations.',
              'Strategic Digital Marketing': 'Grow your business with data-driven digital marketing: SEO, PPC, social media, and content strategies that deliver measurable ROI.',
              'Enterprise Software Development': 'We build scalable, secure enterprise software tailored to your business needs—integrating with your existing systems and boosting productivity.',
              'Custom Applications': 'From CRMs to workflow automation, our custom apps solve unique business challenges and help you stay ahead of the competition.',
              'Cloud Services': 'Migrate to the cloud with confidence. We offer cloud setup, migration, and management for improved efficiency and security.',
              'Branding': 'Comprehensive branding solutions, including logo design, brand identity, and guidelines to make your business stand out.',
              'Cyber Security': 'Protect your digital assets with advanced cybersecurity solutions, including penetration testing, audits, and ongoing monitoring.',
              'Web Hosting': 'Fast, secure, and reliable web hosting with 99.9% uptime and 24/7 support for your business-critical sites.',
              'SEO': 'Boost your online visibility and rank higher on Google with our expert SEO services, including on-page, off-page, and technical SEO.',
              'Consulting': 'Get expert advice on digital strategy, technology selection, and process optimization from our experienced consultants.',
              'Domain Registration': 'Secure your ideal domain name with easy registration, transfer, and management services.',
              'E-Commerce': 'Launch a high-converting online store with secure payment integration and scalable e-commerce platforms.',
              'ERP/CRM': 'Streamline operations and improve customer relationships with our ERP and CRM solutions, customized for your business.',
              'Email Hosting': 'Professional, secure, and reliable business email hosting with anti-spam and easy management.',
              'Maintenance & Support': 'Keep your website and apps running smoothly with our proactive maintenance and 24/7 technical support.',
              'Data Analytics & BI': 'Unlock actionable insights from your data with advanced analytics and business intelligence dashboards.'
            };
            // Extract just the lowest price from ranges (e.g. '$1,000-3,000' becomes '1,000')
            const getLowestPrice = (priceStr: string) => {
              const numericValue = priceStr.replace(/[^0-9-]/g, '').split('-')[0];
              return numericValue; // Return just the number without currency symbol
            };
            const displayPrice = getLowestPrice(limitedOffer || price);
            const originalPrice = limitedOffer ? getLowestPrice(price) : null;
            return (
              <div key={id} className={`service-card ${isPopular ? 'popular-card' : ''}`}>
                {isPopular && <div className="popular-badge">POPULAR</div>}
                {limitedOffer && <div className="discount-banner">LIMITED</div>}
                <div className="card-icon">
                  <Icon className="icon-svg" />
                </div>
                <h3>{title}</h3>
                <p className="card-description">{seoDescriptions[title as keyof typeof seoDescriptions] || description}</p>
                <div className="price-display">
                  <span className="starting-from">Starting from</span>
                  {originalPrice && (
                    <span className="original-price">{originalPrice}</span>
                  )}
                  <span className="current-price">{displayPrice}</span>
                </div>
                <Link to={path} className="card-button">
                  Learn More <span>→</span>
                </Link>
              </div>
            );
          })}
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <WebDesignLocations />
        </div>
      </section>

      {/* FAQ Section for SEO */}
      <section className="faq-section bg-white py-12">
        <div className="container mx-auto px-6">
          <h2 className="text-2xl font-bold mb-4">Frequently Asked Questions</h2>
          <div className="space-y-6">
            <div>
              <h3 className="font-semibold">What makes First Soft UAE different from other web development agencies in the UAE?</h3>
              <p>We offer a full suite of digital services—from design and development to marketing and support—backed by a proven track record, transparent pricing, and dedicated project managers for every client.</p>
            </div>
            <div>
              <h3 className="font-semibold">How long does it take to build a website or app?</h3>
              <p>Most projects are delivered in 2-6 weeks, depending on complexity. We provide clear timelines and regular updates throughout the process.</p>
            </div>
            <div>
              <h3 className="font-semibold">Do you provide ongoing support and maintenance?</h3>
              <p>Yes, First Soft UAE offers 24/7 support and maintenance packages to ensure your website or app stays secure, updated, and running smoothly.</p>
            </div>
            <div>
              <h3 className="font-semibold">Can you help with SEO and digital marketing?</h3>
              <p>Absolutely! Our team specializes in SEO, PPC, content marketing, and social media to help your business grow online.</p>
            </div>
            <div>
              <h3 className="font-semibold">Which industries do you serve?</h3>
              <p>We work with clients in retail, healthcare, education, real estate, hospitality, logistics, e-commerce, and more across the UAE and Middle East.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Internal Links for SEO */}
      <section className="internal-links-section bg-gray-50 py-8">
        <div className="container mx-auto px-6 text-center">
          <span className="font-semibold">Explore more:</span>
          <div className="flex flex-wrap gap-4 justify-center mt-2">
            <Link to="/portfolio" className="underline text-blue-700">Portfolio</Link>
            <Link to="/contact" className="underline text-blue-700">Contact Us</Link>
            <Link to="/web-design-development" className="underline text-blue-700">Web Design</Link>
            <Link to="/mobile-app-development" className="underline text-blue-700">Mobile Apps</Link>
            <Link to="/digital-marketing" className="underline text-blue-700">Digital Marketing</Link>
            <Link to="/seo" className="underline text-blue-700">SEO</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OurServices;
